export default __webpack_public_path__ + "static/media/1.18c83a3e.jpg";